import React from "react";
import { Route } from "react-router";
import { Navigate } from "react-router-dom";
import UIKit from "../components/UIKit";

const useTechRoutes = () => {
  return (
    <Route>
      <Route path="ui-kit" element={<UIKit />}></Route>
      <Route path="" element={<Navigate to="ui-kit" />} />
      <Route path="*" element={<Navigate to="ui-kit" />} />
    </Route>
  )
};

export default useTechRoutes;